import EventManager from "../../../../../manager/event_manager";
import ModelData, { IUserData } from "../../../../public/model_data";
import UserDataManager from "../../../../../manager/user_manager";
import Utility from "../../../../../utility/utility";
import ComponentBase from "../../../../public/component/component_base";

const { ccclass, property } = cc._decorator;

@ccclass
export default class FirendBaseItem extends ComponentBase {
    @property(cc.Label)
    nameLabel: cc.Label = null;

    @property(cc.Sprite)
    iconSprite: cc.Sprite = null;

    @property(cc.Label)
    date: cc.Label = null;

    @property(cc.Label)
    level : cc.Label = null;

    @property([cc.Node])
    genderNodes : cc.Node[] = [];

    @property([cc.Node])
    state : cc.Node[] = [];

    protected currency : number;

    public data : any;

    public friendId : number;

    public index: number;

    protected eventDispatch(event: string,...data : any[]) {

        EventManager.instance.dispatch(event, this.index,data);
    }

    protected eventBind(event,callback){

        EventManager.instance.on(event,callback,this,true);
    }

    protected eventRemove(event,callback){

        EventManager.instance.off(event,callback,this);
    }

    public updateInfo(data: any,currency ? : number) {

        this.currency = currency;

        this.data = data;

        this.friendId = data.friendId;
        
        this.nameLabel.string = data.nickname;

        if (data.createTime && this.date) {

            let date = Utility.formatTime(data.createTime / 1000, "MM/dd/yyyy");
            this.date.string = date;
        }

        if (data.gender && this.genderNodes.length > 0) {

            this.genderNodes.forEach((node, index) => {
                if (index == data.gender - 1) {
                    node.active = true;
                } else {
                    node.active = false;
                }
            });
        }

        this.level.string = "LV." + data.userLevel;

        if (this.state.length > 0) {

            if (data.online) {
                this.state[0].active = true;
                this.state[1].active = false;
            }else{
                this.state[1].active = true;
                this.state[0].active = false;
            }
        }

        //let self = this;
        // this.getUserData(this.friendId,(data:IUserData)=>{
        //     if (self.friendId == data.id) {
        //         self.iconSprite.spriteFrame = data.avatarSprite;
        //     }
        // });
        


        UserDataManager.getAvatarSprite(data.headImg, (spriteFrame) => {
            this.iconSprite.spriteFrame = spriteFrame
        },false,data.gender);
    }

}           